import apiClient from '@disco/api/server'
import type { ClientLibraryId } from 'types/client-library'

import { api } from './index'

export const PAGE_SIZE = 20

export type LicenseRequestSubmissionTrack = {
  id: number
  name: string
  artist: string
  artwork: {
    artwork: string
    artwork_sizes: { full: string; '160x160': string }
  } | null
}

export type LicenseRequestSubmission = {
  id: number
  created: string
  form_version_id: number
  answers: {
    tracks: number[]
    user_name: string
    user_email: string
    playlist?: number
    [key: string]: unknown
  }
  user_id: number
  tracks: LicenseRequestSubmissionTrack[]
}

export type LicenseRequestSubmissionsPage = {
  count: number
  next: string | null
  previous: string | null
  results: LicenseRequestSubmission[]
}

type QueryArg = {
  libraryId: ClientLibraryId
  ordering: string
  page: number
}

export const licenseRequestsApi = api
  .enhanceEndpoints({ addTagTypes: ['LicenseRequestSubmissions'] })
  .injectEndpoints({
    endpoints: build => ({
      getLicenseRequestSubmissions: build.query<
        LicenseRequestSubmissionsPage,
        QueryArg
      >({
        queryFn: async ({ libraryId, ordering, page }) => {
          try {
            const data = await apiClient.getLicenseRequestSubmissions({
              libraryId,
              ordering,
              offset: (page - 1) * PAGE_SIZE,
              pageSize: PAGE_SIZE,
            })
            return { data }
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', error: String(error) } }
          }
        },
        providesTags: (_result, _error, { libraryId }) => [
          { type: 'LicenseRequestSubmissions', id: libraryId },
        ],
      }),
    }),
  })

export const { useGetLicenseRequestSubmissionsQuery } = licenseRequestsApi
